import React from 'react';

import { MULTI_SITE_MODULE_ID, LEAD_ID } from 'home/view/manage-feasibility/constants';

import { getFromSessionStorage } from 'common/utils/app.utils';

const NoRecord = ({ onClearFilter = () => {}, emptySites = false }) => {
  const savedLeadId = getFromSessionStorage(MULTI_SITE_MODULE_ID, LEAD_ID) ?? '';

  return (
    <div class="b2b-lib-noresult" style={{ margin: 30 }}>
      <div class="b2b-lib-resultcontent">
        <h2>No Result Found!</h2>
        <p>We couldn’t find what you are looking for.</p>
        <br />
        {savedLeadId && emptySites && <p>Order Request ID: {savedLeadId}</p>}
        <div class="b2b-lib-btnresult">
          <div class="b2b-lib-transparentbtn" onClick={onClearFilter}>
            {emptySites ? '' : 'Clear Filter'}
          </div>
        </div>
      </div>
      <div>
        <img alt="No Record" src="https://assets.airtel.in/static-assets/b2b-ui-components-lib/images/no-result.svg" />
      </div>
    </div>
  );
};

export default NoRecord;
